import { computed } from 'vue';
import { toValue } from '@vueuse/core';
import { FIELD as FEATURE_FIELD } from '@/components/payments/components/service-plan/components/features/constants.js';
import { FIELD as PLAN_FIELD, GROUP_FIELD } from '@/components/payments/components/service-plan/constants.js';
import {
    getFeatureExhaustion,
    getVisibleFeatures,
} from '@/components/payments/components/service-plan/components/features/utils.js';

export function usePlanFeatures(plan, params = {}) {
    const features = computed(() => Object.values(toValue(plan)?.[PLAN_FIELD.OPTIONS] ?? {}).reduce((result, group) => ({
        ...result,
        ...(group[GROUP_FIELD.FEATURES] ?? {}),
    }), {}));

    return useFeatures(features, params);
}

export default function useFeatures(features, params = {}) {
    const visibleFeatures = computed(() => getVisibleFeatures(toValue(features) ?? {}));
    const featuresParams = computed(() => toValue(params));

    const exhaustion = computed(() => Object.fromEntries(Object.entries(visibleFeatures.value).map(([name, feature]) => [
        feature[FEATURE_FIELD.NAME] ?? name,
        getFeatureExhaustion(feature, featuresParams.value),
    ])));

    const hasExhaustion = computed(() => Object.values(exhaustion.value).some(item => item.exhausted));

    return {
        visibleFeatures,
        exhaustion,
        hasExhaustion,
    };
}
